export enum EventStatuses {
  critical = 'критическое',
  special = 'особое',
  regular = 'штатное',
  info = 'информационное'
}
